import { useQuery } from "@tanstack/react-query";
import {
  RevenueAndExpenseDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_REVENUE_AND_EXPENSES } from "../domain";

import { revenueAndExpensesApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_REVENUE_AND_EXPENSES = "GET_REVENUE_AND_EXPENSES";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

interface GetRevenueAndExpensesRequest {
  companyId: string;
}

const getRevenueAndExpenses = async (
  companyId: string,
): Promise<RevenueAndExpenseDto[]> => {
  const resposne =
    await revenueAndExpensesApi.revenueAndExpensesControllerGetRevenueAndExpenses(
      companyId,
    );

  return resposne.data;
};

export const useGetRevenueAndExpenses = (
  user: UserProfileDto | null,
  params: GetRevenueAndExpensesRequest,
): {
  revenueAndExpenses?: RevenueAndExpenseDto[];
  revenueAndExpensesEnabled: boolean;
  isSuccessGetRevenueAndExpenses: boolean;
  isLoadingGetRevenueAndExpenses: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: [DOMAIN_REVENUE_AND_EXPENSES, ACTION_GET_REVENUE_AND_EXPENSES, params],
    queryFn: () => getRevenueAndExpenses(params.companyId),
    select: (response) => response,
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    revenueAndExpenses: data,
    revenueAndExpensesEnabled: enabled,
    isSuccessGetRevenueAndExpenses: isSuccess,
    isLoadingGetRevenueAndExpenses: isLoading,
  };
};
